import { render, staticRenderFns } from "./RecommendationEditDialog.vue?vue&type=template&id=f6cb2d6a&scoped=true"
import script from "./RecommendationEditDialog.vue?vue&type=script&lang=js"
export * from "./RecommendationEditDialog.vue?vue&type=script&lang=js"
import style0 from "./RecommendationEditDialog.vue?vue&type=style&index=0&id=f6cb2d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cb2d6a",
  null
  
)

export default component.exports